import styled from 'styled-components'

export const ModalContent = styled.div`
  max-width: 500px;
  width: 100%;
`

export const SubTitleContent = styled.div`
  p {
    color: #898989;
  }
`

export const AppointmentTime = styled.div`
  border: 1px solid #FF2929;
  padding: 8px 15px;
  border-radius: 20px;
  text-align: center;
  margin: 0 auto 24px;
  display: block;
  width: fit-content;
`

export const WarningSection = styled.div`
  text-align: center;
  margin-bottom: 16px;
  max-width: 330px;
  margin: 0 auto;
  margin-bottom: 24px;
  gap: 10px;
  display: flex;
  align-items: flex-start;
`

export const WarningSectionCentered = styled.div`
  text-align: center;
  margin-bottom: 16px;
  max-width: 330px;
  margin: 0 auto;
  margin-bottom: 24px;
`

export const PhoneNumber = styled.div`
  text-align: center;
  margin-bottom: 24px;
`

export const WhatsAppSection = styled.div`
  text-align: center;
  margin-bottom: 24px;
`

export const WhatsAppButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 auto;
  padding: 8px;
  border-radius: 4px;
  transition: background-color 0.2s;

  &:hover {
    background-color: #f5f5f5;
  }
`

export const CheckboxSection = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 24px;
  padding: 16px;
  border-radius: 8px;
`

export const CheckboxLabel = styled.label`
  cursor: pointer;
  flex: 1;
`

export const ReasonSection = styled.div`
  margin-bottom: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const RequiredField = styled.div`
  text-align: left;
  margin-bottom: 24px;

  p{
    color: #898989
  }
`

export const CancelLimitPanelWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
`

export const CancelLimitPanel = styled.div`
  display: inline-flex;
  align-items: center;
  background-color: #f5f5f5;
  border-radius: 8px;
  padding: 15px;
  gap: 15px;
`

export const CancelLimitCounter = styled.div<{ isAtLimit: boolean }>`
  font-size: 28px;
  font-weight: bold;
  color: ${({ isAtLimit }) => (isAtLimit ? '#FF2929' : 'inherit')};
  white-space: nowrap;
  min-width: 56px;
  text-align: center;
`

export const CancelLimitDivider = styled.div`
  width: 1px;
  background-color: #d0d0d0;
  align-self: stretch;
`

export const CancelLimitDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`

export const CancelLimitRow = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;

  p {
    margin: 0;
  }
`

export const LimitReachedMessage = styled.div`
  margin-bottom: 24px;
`

export const LoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
`

export const LimitReachedTextContent = styled.div`
  text-align: left;
`

export const FormLink = styled.a`
  display: inline-block;
  margin-top: 24px;
  color: #1F35B5;
  font-weight: bold;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`
